import { render, staticRenderFns } from "./ScrollWrapper.vue?vue&type=template&id=328a178c&scoped=true"
import script from "./ScrollWrapper.vue?vue&type=script&lang=ts"
export * from "./ScrollWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ScrollWrapper.vue?vue&type=style&index=0&id=328a178c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a178c",
  null
  
)

export default component.exports